<div id="businessLine">
  <!-- <h1 class="businessLineHead">Line of Business</h1> -->

  @if (!isLoading) {
    <div class="businessLineRoot">
      @for (lob of lobs; track lob) {
        <div [ngClass]="{'businessItems': true, 'white-background':lob.whiteBackground}">
          @if (!lob.agencyEditMode) {
            <div class="flex-top">
              <h1>{{lob.title}}</h1>
              <div class="agency-line">
                <div class="agency-label">Region:</div>
                <div>{{lob.selectedRegion}}</div>
              </div>
              <div class="agency-line">
                <div class="agency-label">Agency:</div>
                <div>{{lob.selectedAgency}}</div>
              </div>
              <div class="agency-line">
                <div class="agency-label">Agency ID:</div>
                <div>{{lob.selectedAgencyId}}</div>
              </div>
            </div>
            <div class="flex-bottom">
              <div class="item-link" (click)="editAgency(lob)">Change {{lob.title}} Agency@if (lob.showRegionFilter) {
                <span
                >/Region</span>
              }</div>
              <div class='lob-button-container'>
                @if (lob.primaryUrl && !lob.ssoType) {
                  <a color="primary" class="primary button-link" [href]="lob.primaryUrl">{{lob.primaryLabel}}</a>
                }
                @if (lob.ssoType) {
                  <app-sso-handler [lob]="lob.market" [ssoType]="lob.ssoType" [ssoLabel]="lob.primaryLabel" linkType="producer-home-button primary sso-button"></app-sso-handler>
                }
                @for (button of lob.secondaryButtons; track button) {
                  <!-- Even if buttons are not configured we need to add them and set to "invisible" so all the dashboard cards line up -->
                  @if (!button.ssoType) {
                    <a class='button-link' [href]="button.url" [class.invisible]="!button.url">{{button.label}}</a>
                  }
                  @if (button.ssoType) {
                    <app-sso-handler [lob]="lob.market" [ssoType]="button.ssoType" [ssoLabel]="button.label" linkType="producer-home-button sso-button"></app-sso-handler>
                  }
                }
                <!-- If the primary button is hidden, we want to push the secondary ones up by having an 'invisible' entry below -->
                @if (!lob.primaryUrl && !lob.ssoType) {
                  <a color="primary" class="button-link invisible">{{lob.primaryLabel}}</a>
                }
              </div>
            </div>
          }
          @if (lob.agencyEditMode) {
            <div>
              <h1>{{lob.title}}</h1>
              <app-producer-change-agency
                [isAgencyOnlyMode]="true"
                [selectedMarket]="lob.market"
                [showRegionFilter]="lob.showRegionFilter"
                (agencyChangeEvent)="agencyChange($event, lob)"
              ></app-producer-change-agency>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (isLoading) {
    <div class='loading-spinner'>
      <mat-spinner [diameter]="100"></mat-spinner>
    </div>
  }
</div>